import ModuleHeader from './ModuleHeader';

export { type ModuleHeaderProps } from './ModuleHeader';
export default ModuleHeader;
